import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Logo } from "@/components/Logo";
import { toast } from "sonner";

export default function Register() {
  const { user, register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", company: "" });
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (user && !submitting) navigate("/", { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSubmitting(true);
    try {
      await register(form.email, form.password, form.name, form.company);
      toast.success("Cuenta creada · ¡Bienvenido a Cuenta Vaca!");
      navigate("/onboarding", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "No pude crear la cuenta");
      setSubmitting(false);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen relative bg-pampa-dawn noise grid place-items-center px-4 py-10">
      <div className="relative w-full max-w-md">
        <div className="absolute -inset-2 -z-10 rounded-[calc(var(--radius)+0.4rem)] bg-[hsl(var(--brand-ochre)/0.18)] blur-2xl" aria-hidden />
        <div className="relative rounded-[var(--radius)] border border-border bg-card p-7 shadow-paper-hover">
          <div className="flex flex-col items-center text-center mb-6">
            <Logo variant="mark" className="h-14 w-14" />
            <div className="mt-3 font-heading text-[22px] font-semibold tracking-tight text-foreground">
              Creá tu cuenta en <span>Cuenta</span><span className="text-[hsl(var(--primary))]"> Vaca</span>
            </div>
            <p className="text-[12.5px] text-muted-foreground mt-1">Empezá a inventariar en menos de un minuto.</p>
          </div>
          <form onSubmit={submit} className="space-y-4">
            <div className="space-y-1.5">
              <Label htmlFor="name" className="text-[12px] text-muted-foreground">Nombre</Label>
              <Input id="name" data-testid="register-name-input" required value={form.name} onChange={(e)=>setForm({ ...form, name: e.target.value })} className="h-11" />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="company" className="text-[12px] text-muted-foreground">Empresa / Establecimiento (opcional)</Label>
              <Input id="company" data-testid="register-company-input" value={form.company} onChange={(e)=>setForm({ ...form, company: e.target.value })} className="h-11" placeholder="Rimoly South" />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="email" className="text-[12px] text-muted-foreground">Email</Label>
              <Input id="email" data-testid="register-email-input" type="email" required value={form.email} onChange={(e)=>setForm({ ...form, email: e.target.value })} className="h-11" />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="password" className="text-[12px] text-muted-foreground">Contraseña</Label>
              <Input id="password" data-testid="register-password-input" type="password" required value={form.password} onChange={(e)=>setForm({ ...form, password: e.target.value })} className="h-11" minLength={6} placeholder="Mínimo 6 caracteres" />
            </div>
            <Button data-testid="register-submit-button" type="submit" disabled={loading} size="lg" className="w-full">
              {loading ? "Creando…" : "Crear cuenta"}
            </Button>
          </form>
          <div className="mt-5 text-center text-[13px] text-muted-foreground">
            ¿Ya tenés cuenta? <Link to="/login" className="text-primary font-medium hover:underline underline-offset-4" data-testid="register-go-login-link">Iniciar sesión</Link>
          </div>
        </div>
        <p className="text-[10.5px] font-mono text-muted-foreground text-center mt-3 tracking-[0.08em]">
          Rimoly South INC · 2026 · Cuenta Vaca
        </p>
      </div>
    </div>
  );
}
